import { BackendHttpService } from "../backendHttpService";

export class EducationDictionaryService extends BackendHttpService {
    private degreesCache: string[] | null = null;
    private institutionsCache: string[] | null = null;

    constructor() {
        super("Education");
    }

    async getEducationDegrees(): Promise<string[]> {
        if (this.degreesCache) {
            return this.degreesCache;
        }
        try {
            // Backend returns string[] for these endpoints
            this.degreesCache = Array.from(new Set(
                (await this.get<string[]>("/degreesDictionary"))
                    .filter((d): d is string => !!d?.trim())
                    .map((d) => d.trim())
            ));
            return this.degreesCache;
        } catch (error) {
            console.error("Error getting education degrees dictionary:", error);
            throw error;
        }
    }

    async getEducationInstitutions(): Promise<string[]> {
        if (this.institutionsCache) {
            return this.institutionsCache;
        }
        try {
            this.institutionsCache = Array.from(new Set(
                (await this.get<string[]>("/institutionsDictionary"))
                    .filter((i): i is string => !!i?.trim())
                    .map((i) => i.trim())
            ));
            return this.institutionsCache;
        } catch (error) {
            console.error("Error getting education institutions dictionary:", error);
            throw error;
        }
    }

    clearCache(): void {
        this.degreesCache = null;
        this.institutionsCache = null;
    }
}

export const educationDictionaryService = new EducationDictionaryService();
